<template>
  <div class="relative px-4 pt-16 pb-20 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
    <div class="relative mx-auto max-w-7xl">
      <h2
        class="
          text-2xl
          font-bold
          leading-9
          tracking-tight
          text-center
          tmsk-blue-text
        "
      >
        Processing Payment
      </h2>
      <div class="grid max-w-lg gap-4 mx-auto mt-12">
        <div class="flex flex-row items-center justify-center">
          <img class="w-48" :src="getAssets(method.imageUrl)" />
        </div>
        <div class="flex flex-row items-center justify-center mt-4 text-center">
          Please complete your payment within 5 minutes.
        </div>

        <div class="flex flex-row items-center justify-center mt-10">
          <div class="w-10 h-10 border-4 border-teal-100 rounded-full loader" />
        </div>
        <div
          class="
            flex
            items-center
            justify-center
            w-56
            h-56
            mx-auto
            my-3
            sm:w-64 sm:h-64
          "
        >
          <canvas
            class="absolute w-56 h-56 mx-auto mt-3 sm:w-64 sm:h-64 canvas"
          />
          <qr-code
            style="z-index: 5"
            class="w-48 h-48 mt-6 sm:w-60 sm:h-60"
            level="Q"
            :value="qr"
            renderAs="canvas"
            :size="activeBreakpoint === 'sm' ? 192 : 240"
          />
        </div>
        <!-- <div class="flex flex-row items-center justify-center mt-10">
          <div class="w-20 h-20 border-4 border-teal-100 rounded-full loader" />
        </div> -->
        <template v-if="activeBreakpoint === 'sm'">
          <h3 class="mt-4 text-xl font-medium text-center tmsk-blue-text">
            PayNow Guide
          </h3>
          <p class="text-center tmsk-blue-text">
            1. Screenshot and save this QR code in your photo library
          </p>
          <p class="text-center tmsk-blue-text">2. Launch mobile banking app</p>
          <p class="text-center tmsk-blue-text">3. Select scan / pay</p>
          <p class="text-center tmsk-blue-text">
            4. Import and select image from your photo library
          </p>
          <p class="text-center tmsk-blue-text">5. Confirm payment</p>
        </template>
        <template v-else>
          <h3 class="mt-4 text-xl font-medium text-center tmsk-blue-text">
            PayNow Guide
          </h3>
          <p class="text-center tmsk-blue-text">1. Launch iBanking app</p>
          <p class="text-center tmsk-blue-text">2. Scan PayNow QR code</p>
          <p class="text-center tmsk-blue-text">3. Confirm payment</p>
          <p class="text-center tmsk-blue-text">4. Complete transaction</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import beepAPI from '@/mixins/beepAPI'
import { mapActions, mapGetters } from 'vuex'
import QrCode from 'qrcode.vue'
export default {
  name: 'PayNow',
  components: {
    QrCode
  },
  mixins: [beepAPI],
  props: {
    uuid: {
      type: String,
      required: true
    },
    method: {
      type: Object,
      required: true
    },
    qr: {
      type: String,
      required: true
    },
    expiryTimestamp: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      hasTimeout: false
    }
  },
  computed: {
    ...mapGetters(['activeBreakpoint'])
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.paintCanvas()
    this.commencePolling()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateSuccessfulPurchase']),

    paintCanvas () {
      var collection = document.querySelectorAll('.canvas')
      for (let i = 0; i < collection.length; i++) {
        const canvas = collection[i]
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
      }
    },

    commencePolling () {
      const body = {
        uuid: this.uuid,
        expiryTimestamp: this.expiryTimestamp
      }

      this.getPaymentStatus(body)
        .then(
          async response => {
            const { status, success, message } = response
            if (status === 'success') {
              await this.updateSuccessfulPurchase(response)
              this.$emit('success')
            } else if (status === 'cancelled') {
              if (!this.hasTimeout) {
                this.hasTimeout = true
                this.createModal({
                  title: 'Something went wrong',
                  message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                  btnMessage: 'Proceed',
                  callback: () => {
                    this.$emit('failed')
                  }
                })
              }
            } else if (success === false) {
              this.createModal({
                title: 'Something went wrong',
                message: message,
                btnMessage: 'Proceed',
                callback: () => {
                  this.$emit('failed')
                }
              })
            } else if (this.uuid != null) {
              setTimeout(this.commencePolling, 1000)
            }
          },
          (error) => {
            if (!error.response || error.response.status === 0) {
              this.commencePolling()
            } else {
              this.createModal({
                title: 'Something went wrong',
                message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                btnMessage: 'Proceed',
                callback: () => {
                  this.$emit('failed')
                }
              })
            }
          }
        )
    },

    getAssets (img) {
      if (!img) return
      return require('@/assets/img/' + img)
    }
  }
}
</script>

<style scoped>
.loader {
  border-top-color: #16bdca;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
